var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('RegisterStudyFormPartner',{attrs:{"isShow":true,"contract_prop":_vm.contract,"verify_prop":_vm.verify}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-title"},[_c('p',[_vm._v("Xem phiếu đăng ký học tập")])])])
}]

export { render, staticRenderFns }